__turbopack_context__.v({
  "bar": "LoadingOverlay-module-scss-module__FFhbwa__bar",
  "fadeIn": "LoadingOverlay-module-scss-module__FFhbwa__fadeIn",
  "loadingGradient": "LoadingOverlay-module-scss-module__FFhbwa__loadingGradient",
  "overlay": "LoadingOverlay-module-scss-module__FFhbwa__overlay",
});
